/**
 * Identifies events emitted by various layout containers.
 *
 * @module MW/layout/LayoutContainerEvent
 * @copyright Copyright 2014-2017 The MathWorks, Inc.
 */
define([], function () {
    return {
        /**
         * Emitted when the restorable state of a container changes
         * @static
         */
        STATE_CHANGED: "state_changed",

        /**
         * Emitted when a child is added to the container
         * @static
         */
        CHILD_ADDED: "child_added",

        /**
         * Emitted when a child is removed from the container
         * @static
         */
        CHILD_REMOVED: "child_removed",

        /**
         * Obsolete
         * @static
         */
        DRAG_OUT_INITIATED: "drag_out_initiated",

        /**
         * Emitted when a child is dragged out of the container
         * @static
         */
        DRAG_OUT: "drag_out",

        /**
         * Emitted when expand all is triggered
         * @static
         */
        EXPAND_ALL: "expand",

        /**
         * Emitted when collapse all is triggered
         * @static
         */
        COLLAPSE_ALL: "collapse",

        /**
         * Emitted when the user begins dragging a splitter
         * @static
         */
        SPLITTER_DRAG_STARTED: "splitterDragStarted",

        /**
         * Emitted when the user finishes dragging a splitter
         * @static
         */
        SPLITTER_DRAG_ENDED: "splitterDragEnded",

        /**
         * Emitted when close is triggered
         * @static
         */
        CLOSE: "close"
    };
});